export const russianData = {
	personalInformation: `Я Fullstack-разработчик. У меня есть навыки создания надежных и масштабируемых веб-приложений. Имею 3-летний опыт коммерческой разработки. Имею среднее образование и сейчас получаю высшее. Моя цель — использовать свой опыт для создания решений, способствующих росту бизнеса и обеспечивающих исключительного пользовательского опыта.`,
	aboutText: `Я начал изучать программирование еще в 2018 году, когда поступил в колледж. Это занятие мне сразу понравилось, вскоре оно переросло в хобби. Будучи в колледже, я не знал, в какую область программирования мне стоит погружаться, поэтому изучал все понемногу. Сейчас у меня уже есть трехлетний практический опыт разработки веб-приложений. За это время мне довелось поработать со многими технологиями, например: Vue, Node.js, PostgreSQL, Rust, GraphQL. Мой путь веб-разработки начался с глубокого любопытства к тому, как все работает, и перерос в карьеру, в которой я постоянно стремлюсь учиться и адаптироваться к новым задачам. Я получаю удовольствие от решения сложных проблем для предоставления высококачественных решений.`,
	experience: [
		{
			year: 'Сентябрь 2023 - Настоящее время',
			role: 'Middle Frontend разработчик',
			company: 'AISA',
			description: `Разработка веб части юридического портала.`,
			technologies: ['TypeScript', 'Vue 3', 'Quasar', 'Git', 'TipTap'],
		},
		{
			year: 'Июнь 2021 - Август 2023',
			role: 'FullStack разработчик',
			company: 'UBTec',
			description: `Разрабатывал систему отслеживания задач, предназначенную для организации взаимодействия с пользователями и управления проектами. Участвовал в создании Frontend и Backend.`,
			technologies: [
				'Vue 2',
				'Rust',
				'Vuetify',
				'Postgres',
				'GraphQL',
				'JavaScript',
				'Git',
			],
		},
		{
			year: 'Октябрь 2021 - Ноябрь 2021',
			role: 'Стажер в рамках практики',
			company: 'Sebbia',
			description: `В рамках своей практики в колледже я разработал API для создания встроенных историй.`,
			technologies: ['Kotlin', 'Graphql', 'Postgres', 'Git'],
		},
		{
			year: 'Июль 2020 - Октябрь 2020',
			role: 'Junior разработчик',
			company: 'FastReport',
			description: `В компанию я попал во время стажировки в колледже. Участвовал в разработке системы создания документации.`,
			technologies: ['.Net', 'C#', 'WPF', 'Linux', 'Git'],
		},
	],
	contacts: {
		address: 'Россия, Ростов-на-Дону',
		phoneNo: '+7 993 447 30 09 ',
		email: 'matyash.danil@mail.ru',
	},
}
